import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import ProductDetails from "./ProductDetails";
import PackageDetails from "./PackageDetails";
import SubscriptionDetails from "./SubscriptionDetails";
import UserDetails from "./UserDetails";
import DashboardDetails from "./DashboardDetails";
import { Helmet } from "react-helmet";

function AdminPanel() {
  const [activeKey, setActiveKey] = useState("user");

  const renderTabContent = () => {
    switch (activeKey) {
      case "user":
        return <UserDetails />;
      case "dashboard":
        return <DashboardDetails />;
      case "product":
        return <ProductDetails />;
      case "package":
        return <PackageDetails />;
      case "subscription":
        return <SubscriptionDetails />;
      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Admin Panel | EMAlpha</title>
      </Helmet>
      <div className="flex" style={{ height: "8%" }}></div>
      <div
        className="bg-white p-3 rounded-4 rounded-left"
        style={{ height: "92%" }}
      >
        <div
          className="AdminPanel container mt-2"
          style={{ height: "100%", overflow: "auto" }}
        >
          <Tabs
            activeKey={activeKey}
            onSelect={(k) => setActiveKey(k)}
            id="admin-panel-tabs overflow-auto"
            className="mb-3"
          >
            <Tab
              eventKey="user"
              title="User"
              className="border p-2 border-right "
            >
              <div className="tab-content p-2"> {renderTabContent()}</div>
            </Tab>
            <Tab
              eventKey="dashboard"
              title="Dashboard"
              className="border p-2 border-right"
            >
              <div className="tab-content p-2 "> {renderTabContent()}</div>
            </Tab>
            <Tab
              eventKey="product"
              title="Product"
              className="border p-2 border-right"
            >
              <div className="tab-content p-2 "> {renderTabContent()}</div>
            </Tab>
            <Tab
              eventKey="package"
              title="Package"
              className="border p-2 border-right"
            >
              <div className="tab-content p-2  p-2 h-auto overflow-auto">
                {" "}
                {renderTabContent()}
              </div>
            </Tab>
            <Tab
              eventKey="subscription"
              title="Subscription"
              className="border p-2 border-right"
            >
              <div className="tab-content p-2 h-auto overflow-auto  ">
                {" "}
                {renderTabContent()}
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
}

export default AdminPanel;
